import { render, staticRenderFns } from "./Std.vue?vue&type=template&id=3c72c18d&"
import script from "./Std.vue?vue&type=script&lang=js&"
export * from "./Std.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports